import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import {
  Languages,
  Search,
  CheckCircle2,
  Circle,
  ChevronRight,
  Braces,
  ListChecks,
  AlertTriangle,
} from "lucide-react";
import { elakayAutoText } from "../../pageInside/dataElakay";

import "./CheckLngtofinish.css";

const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#d1fae5",
  amber: "#f59e0b", amberLt: "#fef3c7",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

const ntInclu = ['id', '_id', 'translator', 'supervisor', 'Admin', 'language', 'createdAt', 'updatedAt', '__v'];

const needArray = (a, n) => a.filter(v => !n.includes(v));
const getArray  = (a, oA) => a.filter(v => Array.isArray(oA[v]));
const getObj    = (a, oA) => a.filter(v => !Array.isArray(oA[v]));

const objStringConpare = (os1, os2) =>
  os1 !== null && os1 !== '' && os1 !== undefined && os2 !== null && os2 !== '' && os2 !== undefined;

const objEqual1 = (o1, o2) =>
  o1 !== null && o2 !== null && typeof o1 === 'object' && Object.keys(o1)?.length > 0 && Object.keys(o1)?.length === Object.keys(o2)?.length
    ? Object.keys(o2).every(p => objStringConpare(o1[p], o2[p]))
    : false;

const checkProductTrue = (ad, ei) => {
  let array = objEqual1(ad, ei) ? Object.values(ad)?.map(e => e !== '') : false;
  return !array ? false : array.every(a => a === true);
};

const checkProductArrTrue = (ad) => ad && ad?.length > 0 ? true : false;

const CheckLngToFinish = (props) => {
  const {
    elakayInfo,
    languageTradictor,
    showCheckLang = true,
    setShowCheckLang,
    activeLink,
    clickPageseleted,
    linksData,
  } = props;

  const [search, setSearch] = useState('');

  const goToKey = (key) => {
    activeLink(key);
    clickPageseleted(key);
    setShowCheckLang(false);
  };

  const allKeys_El   = needArray(Object.keys(elakayInfo || {}), ntInclu);
  const allObjKeys_El = getObj(allKeys_El, elakayInfo);
  const allArrKeys_El = getArray(allKeys_El, elakayInfo);

  const doneObjKeys = allObjKeys_El.filter(k => checkProductTrue(languageTradictor?.[k], elakayInfo[k]));
  const doneArrKeys = allArrKeys_El.filter(k => checkProductArrTrue(languageTradictor?.[k]));
  const doneObjSet = new Set(doneObjKeys);
  const doneArrSet = new Set(doneArrKeys);

  const totalKeys = allObjKeys_El.length + allArrKeys_El.length;
  const doneKeys  = doneObjKeys.length + doneArrKeys.length;
  const percent   = totalKeys > 0 ? Math.round((doneKeys / totalKeys) * 100) : 0;

  const q = search.trim().toLowerCase();
  const matchesSearch = (key) => {
    if (!q) return true;
    const label = String(linksData?.[key] || key).toLowerCase();
    return label.includes(q) || key.toLowerCase().includes(q);
  };

  const filteredObjKeys = allObjKeys_El.filter(matchesSearch);
  const filteredArrKeys = allArrKeys_El.filter(matchesSearch);

  const Row = ({ keyName, done }) => (
    <button
      type="button"
      onClick={() => goToKey(keyName)}
      style={{
        display: "flex", alignItems: "center", gap: 8, width: "100%",
        padding: "8px 10px", marginBottom: 2, borderRadius: 8, border: "none",
        background: "transparent", cursor: "pointer", textAlign: "left",
        fontFamily: D.font, transition: "background .12s",
      }}
      onMouseEnter={e => { e.currentTarget.style.background = D.bg; }}
      onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
    >
      {done
        ? <CheckCircle2 size={16} color={D.green} style={{ flexShrink: 0 }} />
        : <Circle size={16} color={D.amber} style={{ flexShrink: 0 }} />}
      <span style={{ flex: 1, fontSize: 13, color: D.txt1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {linksData?.[keyName] || keyName}
      </span>
      <ChevronRight size={14} color={D.txt3} style={{ flexShrink: 0 }} />
    </button>
  );

  const SectionCard = ({ icon, title, items, doneSet, doneCount, total }) => (
    <div style={{ background: "#fff", border: `1px solid ${D.border}`, borderRadius: 12, overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "12px 14px", borderBottom: `1px solid ${D.border}` }}>
        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 26, height: 26, borderRadius: 8, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
          {icon}
        </span>
        <h3 style={{ flex: 1, fontSize: 12, fontWeight: 700, color: D.txt2, margin: 0, textTransform: "uppercase", letterSpacing: .5 }}>
          {title}
        </h3>
        <span style={{
          fontSize: 11, fontWeight: 700, padding: "2px 9px", borderRadius: 10, flexShrink: 0,
          color: total > 0 && doneCount === total ? "#065f46" : "#92400e",
          background: total > 0 && doneCount === total ? D.greenLt : D.amberLt,
        }}>
          {doneCount}/{total}
        </span>
      </div>
      <div className="check-lng-list" style={{ maxHeight: 360, overflowY: "auto", padding: 6 }}>
        {items.length === 0
          ? <div style={{ padding: "20px 12px", textAlign: "center", fontSize: 12, color: D.txt3 }}>
              {elakayAutoText("h_3a7c9e1b6d2f48", "Aucun résultat")}
            </div>
          : items.map(key => <Row key={key} keyName={key} done={doneSet.has(key)} />)}
      </div>
    </div>
  );

  return (
    <Modal
      size="xl"
      show={showCheckLang}
      onHide={() => setShowCheckLang(false)}
      centered
      scrollable
      aria-labelledby="check-lng-to-finish-title"
    >
      <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
        <Modal.Title id="check-lng-to-finish-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 36, height: 36, borderRadius: 10, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
            <Languages size={18} />
          </span>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: D.txt1 }}>
              {elakayAutoText("h_c1a209f3b7c441", "Suivi des traductions")}
            </div>
            <div style={{ fontSize: 12, color: D.txt3, fontWeight: 400 }}>
              {elakayAutoText("h_8a52e6f0d1c934", "Retrouvez en un coup d'œil les pages restant à traduire")}
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
        {/* Overall progress */}
        <div style={{ background: "#fff", border: `1px solid ${D.border}`, borderRadius: 12, padding: "14px 18px", marginBottom: 16 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: D.txt2, textTransform: "uppercase", letterSpacing: .6 }}>
              {elakayAutoText("h_2e1d4a7c0f9b35", "Progression globale")}
            </span>
            <span style={{ fontSize: 13, fontWeight: 700, color: percent === 100 ? D.green : D.txt1 }}>
              {doneKeys} / {totalKeys} ({percent}%)
            </span>
          </div>
          <div style={{ height: 8, borderRadius: 6, background: D.border, overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${percent}%`, background: percent === 100 ? D.green : D.blue, transition: "width .3s ease" }} />
          </div>
        </div>

        {/* Search */}
        <div style={{ position: "relative", marginBottom: 16 }}>
          <Search size={14} color={D.txt3} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }} />
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder={elakayAutoText("h_5f3c8e2b9a1d67", "Rechercher une page…")}
            style={{ width: "100%", padding: "9px 12px 9px 34px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, outline: "none", boxSizing: "border-box", fontFamily: D.font, background: "#fff" }}
          />
        </div>

        {totalKeys === 0 ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "14px 16px", background: D.amberLt, borderRadius: 10, border: "1px solid #fde68a" }}>
            <AlertTriangle size={16} color="#92400e" style={{ flexShrink: 0 }} />
            <span style={{ fontSize: 12, color: "#92400e", fontWeight: 500 }}>
              {elakayAutoText("h_7d4f1a6c8b2e93", "Aucune donnée de référence disponible pour le moment.")}
            </span>
          </div>
        ) : (
          <div className="check-lng-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <SectionCard
              icon={<Braces size={14} />}
              title={elakayAutoText("h_9b6e3d1a4c7f82", "Pages texte")}
              items={filteredObjKeys}
              doneSet={doneObjSet}
              doneCount={doneObjKeys.length}
              total={allObjKeys_El.length}
            />
            <SectionCard
              icon={<ListChecks size={14} />}
              title={elakayAutoText("h_4c8a2e7b1d9f56", "Pages listes")}
              items={filteredArrKeys}
              doneSet={doneArrSet}
              doneCount={doneArrKeys.length}
              total={allArrKeys_El.length}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ background: D.bg, borderTop: `1px solid ${D.border}`, fontFamily: D.font }}>
        <button
          type="button"
          onClick={() => setShowCheckLang(false)}
          style={{ padding: "8px 18px", borderRadius: 8, border: `1px solid ${D.border}`, background: "#fff", color: D.txt2, fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
        >
          {elakayAutoText("h_1f6b9d3a8e4c72", "Fermer")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckLngToFinish;
